import { Box, Grid, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"

const AnswerHeader = ({isCatalog}:{isCatalog?:boolean}) => {
    const styles = useStyles()
    const { t } = useTranslation()

    return (
        <Grid container spacing={2} >
            <Grid item xs={5} />

            <Grid item xs={7}>
                <Box sx={styles.item}>
                    <Typography textAlign='center' variant="subtitle" fontWeight='bold' color='primary.100'>{t('general.evidence')}</Typography>
                    <Typography textAlign='center' variant="subtitle" fontWeight='bold' color='primary.100'>{t('general.actionPlan')}</Typography>
                    <Typography textAlign='center' variant="subtitle" fontWeight='bold' color='primary.100'>{t('general.reportFolio')}</Typography>
                    {!isCatalog && <Typography textAlign='center' variant="subtitle" fontWeight='bold' color='primary.100'>{t('general.recurrenceAlert')}</Typography>}
                </Box>
            </Grid>
        </Grid>
    )
}

export { AnswerHeader }
